import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'eligibility_guide'
const storeType = 'eligibilityGuides'

export const PEEligibilityGuideCardActions = {
  initPeEligibilityGuideCard: ({ commit }, index) => {
    commit('setPeEligibilityGuideCardLock', { index, lock: true })
  },
  peFetchEligibilityGuideCards: async ({ commit, getters, dispatch }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
        if (!assistantCards.length) dispatch('peEligibilityGuideCardAddSection')
      })
  },
  peEligibilityGuideCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            harm_rising: section.harm_rising,
            harm_motive: section.harm_motive,
            harm_agent: section.harm_agent,
            failure_of_state: section.failure_of_state,
            internal_relocation: section.internal_relocation,
            filed_within_one_year: section.filed_within_one_year,
            no_crime_bars: section.no_crime_bars,
            no_national_security: section.no_national_security,
            no_firm_resettlement: section.no_firm_resettlement,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeEligibilityGuideCardLock', { index: 'new', lock: true })
        commit('setPeEligibilityGuideCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peEligibilityGuideCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeEligibilityGuideCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peEligibilityGuideCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            party_id: party.id,
            harm_rising: section.harm_rising,
            harm_motive: section.harm_motive,
            harm_agent: section.harm_agent,
            failure_of_state: section.failure_of_state,
            internal_relocation: section.internal_relocation,
            filed_within_one_year: section.filed_within_one_year,
            no_crime_bars: section.no_crime_bars,
            no_national_security: section.no_national_security,
            no_firm_resettlement: section.no_firm_resettlement,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeEligibilityGuideCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peEligibilityGuideCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeEligibilityGuideCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peEligibilityGuideCardAddSection: ({ commit }) => {
    commit('setPeEligibilityGuideCardLock', { index: 'new', lock: false })
    commit('addPeEligibilityGuideCardSection', {
      id: null,
      harm_rising: false,
      harm_motive: false,
      harm_agent: false,
      failure_of_state: false,
      internal_relocation: false,
      filed_within_one_year: false,
      no_crime_bars: false,
      no_national_security: false,
      no_firm_resettlement: false,
    })
  },
}

export const PEEligibilityGuideCardMutations = {
  setPeEligibilityGuideCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.EligibilityGuideCard) {
      Vue.set(state.partyEdit.partySections, 'EligibilityGuideCard', {})
    }
    Vue.set(state.partyEdit.partySections.EligibilityGuideCard, index, lock)
  },
  addPeEligibilityGuideCardSection: (state, section) => {
    state.partyEdit.asylumAssystant[storeType].push(section)
  },
  peEligibilityGuideCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.EligibilityGuideCard, 'new', true)
  },
}

export const PEEligibilityGuideCardGetters = {
  peEligibilityGuideCardLock: state => index => state.partyEdit.partySections.EligibilityGuideCard[index],
  peEligibilityGuideCardHasNewSection: state => !!state.partyEdit.asylumAssystant[storeType]?.find(i => i.id === null),
}
